import { Box, Button, Spinner, TextField } from "@nike/eds";
import { Size } from "../../../shared/Types";
import { useEffect, useState } from "react";
import { StoreDispatch } from "../../../shared/store/Store";
import { useDispatch, useSelector } from "react-redux";
import { selectLoadingForm, storeProductSize } from "../../../shared/store/reducers/OverviewReducer";

type FormComponentProps = {
    size: Size | null,
    type: 'update' | 'create'
};

export function FormComponent({ size, type }: FormComponentProps) {    
    const dispatch: StoreDispatch = useDispatch();
    
    const isLoading: boolean = useSelector(selectLoadingForm);

    const [grossWeight, setGrossWeight] = useState(size?.grossWeight || '');
    const [sizeCode, setSizeCode] = useState(size?.productWeightsKey.size || '');
    const [sizeCodeError, setSizeCodeError] = useState('');
    const [grossWeightError, setGrossWeightError] = useState('');

    useEffect(() => {
        setGrossWeight(size?.grossWeight || '');
        setSizeCode(size?.productWeightsKey.size || '');
    }, [size]);

    var classNameSize = 'readonly';
    var onSizeCodeChange = (e: any) => {};
    var buttonLabel = 'Update Size';
    if (type === 'create') {
        classNameSize = '';
        onSizeCodeChange = (e: any) => setSizeCode(e.target.value.replace(',', '.'));
        buttonLabel = 'Create Size';
    }

    const isValid = () => {
        var isValid = true;

        setSizeCodeError('');
        setGrossWeightError('');

        if (!sizeCode) {
            setSizeCodeError('Size is required');
            isValid = false;
        }

        if (!grossWeight) {
            setGrossWeightError('Gross weight is required');
            isValid = false;
        }

        if (isNaN(Number(grossWeight))) {
            setGrossWeightError('Gross weight needs to be a number');
            isValid = false;
        }
        
        if (Number(grossWeight) <= 0) {
            setGrossWeightError('Gross weight needs to be greater than 0');
            isValid = false;
        }

        return isValid;
    }

    const onSubmit = () => {
        if (isValid()) {
            dispatch(storeProductSize({
                productCode: size?.productWeightsKey.productCode.trim(),
                size: sizeCode,
                grossWeight: grossWeight,
                weightUnitOfMeasure: 'GRAM'
            }));
        }   
    }

    return (
       <Box>
            <Box mt={100} className={isLoading ? 'loader' : 'hidden'}>
                <Spinner size="large" />
            </Box>

            <Box className={isLoading ? 'hidden' : ''}>
                <Box>
                    <TextField
                        id="size-input" 
                        label="Size"
                        value={sizeCode}
                        className={classNameSize}
                        onChange={onSizeCodeChange}
                        hasErrors={!!sizeCodeError}
                        errorMessage={sizeCodeError}
                    />
                </Box>

                <Box mt={25}>
                    <TextField
                        id="weight-input" 
                        label="Weight"
                        value={grossWeight}
                        message="Weight in grams"
                        onChange={(e: any) => setGrossWeight(e.target.value)}
                        hasErrors={!!grossWeightError}
                        errorMessage={grossWeightError}
                    />
                </Box>

                <Box mt={25}>
                    <Button onClick={onSubmit}>{buttonLabel}</Button>
                </Box>
            </Box>
       </Box>
    )
}